import { Component, Input, OnInit }      from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal }                from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-image-viewer',
  template: require('./image-viewer.component.html'),
  styles: [require('./image-viewer.component.scss')]
})
export class ImageViewerComponent implements OnInit {
  public sanitizedSrc : SafeResourceUrl;

  @Input() hasFooter  = false;
  @Input() isZoomable = false;
  @Input() src : string;

  constructor(
    public activeModal  : NgbActiveModal,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit () : void {
    this.sanitizedSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(this.src);
  }
}
